<template>
  <validation-observer
    #default="{ handleSubmit }"
    ref="refFormObserver"
  >

    <b-form
      class=""
      @submit.prevent="handleSubmit(onSubmit)"
    >

      <b-row>
        <b-col
          cols="12"
          md="8"
        >
          <!-- Left Form -->
          <b-card no-body>
            <b-card-header class="flex-column align-items-start">
              <b-card-title>Confirma la dirección de entrega</b-card-title>
              <b-card-text class="text-muted mt-25">
                Asegúrate de que la dirección registrada coincida con la de entrega antes de continuar.
              </b-card-text>
            </b-card-header>
            <b-card-body>
              <b-card :title="addressDetails.clinic_name">
                <b-card-text class="mb-0">
                  {{ addressDetails.address }}
                </b-card-text>
                <b-card-text>{{ addressDetails.city }}, {{ addressDetails.department }}</b-card-text>
                <hr>
                <label class="section-label mb-1">Clínica</label>
                <b-card-text>Celular: {{ addressDetails.clinic_phone }}</b-card-text>
                <b-card-text>WhatsApp: {{ addressDetails.clinic_whatsapp }}</b-card-text>
                <hr>
                <label class="section-label mb-1">Odontologo</label>
                <b-card-text>Nombre: {{ addressDetails.dentist_full_name }}</b-card-text>
                <b-card-text>Celular: {{ addressDetails.dentist_phone }}</b-card-text>
                <b-card-text>Correo: {{ addressDetails.dentist_email }}</b-card-text>
<!--                <b-button
                  variant="info"
                  @click="$emit('next-step')"
                >
                  Agregar otra dirección de entrega
                </b-button>-->
              </b-card>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <!-- Right Col -->


          <div class="checkout-options">
            <b-card>

              <label class="section-label mb-1">Detalle</label>

              <hr>
              <div class="price-details">
                <!--                <h6 class="price-title">
                  Price Details
                </h6>-->

                <detail-payment-checkout :payment-details="paymentDetails"/>

                <b-button
                    variant="success"
                    block
                    @click="$emit('next-step')"
                >
                  Confirmar / Pagar
                </b-button>
              </div>

            </b-card>
          </div>



        </b-col>
      </b-row>

    </b-form>
  </validation-observer>
</template>

<script>
import {
  BForm,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BFormInvalidFeedback,
  BInputGroupAppend, BInputGroup, BMediaAside, BMedia, BAvatar, BMediaBody,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import { required, integer } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import DetailPaymentCheckout from '@/views/admin/payment/DetailPaymentCheckout.vue'

export default {
  components: {
    DetailPaymentCheckout,
    BMediaBody,
    BAvatar,
    BMedia,
    BMediaAside,
    BInputGroup,
    BInputGroupAppend,
    // BSV
    BForm,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BFormInvalidFeedback,

    // Form Validation
    ValidationProvider,
    ValidationObserver,

    // 3rd party
    vSelect,
  },
  props: {
    addressDetails: {
      type: Object,
      required: true,
    },
    paymentDetails: {
      type: Object,
      required: true,
    },
  },
  setup(_, { emit }) {
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(() => {})

    const onSubmit = () => {
      emit('next-step')
    }

    return {

      // Form
      onSubmit,

      // Form Validation
      refFormObserver,
      getValidationState,
      resetForm,

      // FOrm Validators
      required,
      integer,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
